import { observer } from 'mobx-react-lite'
import { InventoryItemFormContainer } from '@/features/inventory/admin/components/InventoryItemForm/InventoryItemFormContainer'
import { type CreateWorkspaceInventoryItemDialogViewModel } from './CreateWorkspaceInventoryItemDialogViewModel'
import { InventoryItemFormWorkspaceDropdownContainer } from '@/features/inventory/admin/components/InventoryItemFormWorkspaceDropdown/InventoryItemFormWorkspaceDropdownContainer'

export interface CreateWorkspaceInventoryItemDialogContainerProps {
  vm: CreateWorkspaceInventoryItemDialogViewModel
}

export const CreateWorkspaceInventoryItemDialogContainer = observer(
  function CreateWorkspaceInventoryItemDialogContainer({
    vm,
  }: CreateWorkspaceInventoryItemDialogContainerProps) {
    return (
      <InventoryItemFormContainer
        vm={vm}
        title="Add workspace specific service item"
        submitText="Add new"
      >
        <InventoryItemFormWorkspaceDropdownContainer vm={vm} />
      </InventoryItemFormContainer>
    )
  },
)
